
























































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import OrderBankDarahSvc from "@/services/OrderBankDarah";
import {
  OpsiNilai,
  OrderRingkas,
  OrderSumber,
  SerahTerimaSampelDarah,
  STATUS_WARNA
} from "@/types/order_bank_darah";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";

function formKosong(): SerahTerimaSampelDarah {
  return {
    id: undefined,
    diterima_at: moment().format("YYYY-MM-DD HH:mm:00"),
    golongan_darah: null,
    rhesus: null,
    sampel_ada: true,
    komponen_diminta: null,
    jumlah_permintaan: null,
    jumlah_tersedia: null,
    jaminan: null,
    keterangan: null,
    petugas_penerima_nama: null,
    signed_penerima_at: null,
    pengantar_nama: null,
    pengantar_jabatan: null,
    pengantar_jabatan_lain: null,
    is_locked: false
  };
}

@Component({ components: { VCDateTimePicker } })
export default class SerahTerimaDarahDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: String, default: null }) readonly sumber!: OrderSumber | null;
  @Prop({ type: Number, default: null }) readonly orderId!: number | null;
  @Prop({ type: Array, default: () => [] }) readonly peringatanPersetujuan!: string[];

  loading = false;
  saving = false;
  deleting = false;
  dialogHapus = false;
  order: OrderRingkas | null = null;
  form: SerahTerimaSampelDarah = formKosong();
  alasanTidakBisaHapus: string | null = null;
  jabatanItems: OpsiNilai[] = [];

  readonly golonganItems = ["A", "B", "O", "AB"];
  readonly rhesusItems = [
    { value: "positif", text: "Positif" },
    { value: "negatif", text: "Negatif" }
  ];

  get terkunci(): boolean {
    return !!this.form.is_locked;
  }

  get namaPenerima(): string {
    if (this.terkunci && this.form.petugas_penerima_nama) {
      return this.form.petugas_penerima_nama;
    }
    return (userModule.user && userModule.user.nama) || "-";
  }

  get diterimaAt(): Date | null {
    const v = this.form.diterima_at;
    return v ? composeDate(v.slice(0, 10), v.slice(11, 16)) : null;
  }
  set diterimaAt(val: Date | null) {
    this.form.diterima_at = val ? `${toDateString(val)} ${toTimeString(val)}:00` : null;
  }

  @Watch("value")
  onBuka(val: boolean) {
    if (val) this.muat();
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  waktu(val: string | null | undefined): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  async muat() {
    if (!this.sumber || !this.orderId) return;

    this.loading = true;
    this.order = null;
    this.form = formKosong();
    this.alasanTidakBisaHapus = null;

    try {
      const res = await OrderBankDarahSvc.showSerahTerima(this.sumber, this.orderId);
      this.order = res.order;
      this.jabatanItems = res.jabatan_options || [];
      this.alasanTidakBisaHapus = res.alasan_tidak_bisa_hapus;
      this.form = res.serah_terima
        ? { ...formKosong(), ...res.serah_terima }
        : { ...formKosong(), ...(res.prefill || {}) };
    } catch {
      this.tutup();
    } finally {
      this.loading = false;
    }
  }

  cekIsian(): string | null {
    if (!this.form.diterima_at) return "Tanggal & jam diterima wajib diisi.";
    if (this.form.sampel_ada) {
      if (!this.form.pengantar_nama || !String(this.form.pengantar_nama).trim()) {
        return "Nama petugas pengantar wajib diisi.";
      }
      if (!this.form.pengantar_jabatan) return "Jabatan petugas pengantar wajib dipilih.";
    }
    if (this.form.pengantar_jabatan === "lainnya" && !this.form.pengantar_jabatan_lain) {
      return "Sebutkan jabatan pengantar.";
    }
    return null;
  }

  async simpan() {
    if (!this.sumber || !this.orderId) return;

    const kurang = this.cekIsian();
    if (kurang) {
      appModule.sendErrorAlert(kurang);
      return;
    }

    this.saving = true;
    try {
      const res = await OrderBankDarahSvc.simpanSerahTerima(this.sumber, this.orderId, {
        diterima_at: this.form.diterima_at,
        golongan_darah: this.form.golongan_darah,
        rhesus: this.form.rhesus,
        sampel_ada: this.form.sampel_ada,
        komponen_diminta: this.form.komponen_diminta,
        jumlah_permintaan: this.form.jumlah_permintaan,
        jumlah_tersedia: this.form.jumlah_tersedia,
        jaminan: this.form.jaminan,
        keterangan: this.form.keterangan,
        pengantar_nama: this.form.pengantar_nama,
        pengantar_jabatan: this.form.pengantar_jabatan,
        pengantar_jabatan_lain:
          this.form.pengantar_jabatan === "lainnya" ? this.form.pengantar_jabatan_lain : null
      });
      appModule.sendSuccessNotice(res.message);
      this.order = res.data.order;
      this.alasanTidakBisaHapus = res.data.alasan_tidak_bisa_hapus;
      this.form = { ...formKosong(), ...res.data.serah_terima };
      this.$emit("saved");
    } catch {
      return;
    } finally {
      this.saving = false;
    }
  }

  async hapus() {
    if (!this.sumber || !this.orderId || this.deleting) return;

    this.deleting = true;
    try {
      const res = await OrderBankDarahSvc.hapusSerahTerima(this.sumber, this.orderId);
      appModule.sendSuccessNotice(res.message);
      this.dialogHapus = false;
      this.$emit("saved");
      this.tutup();
    } catch {
      return;
    } finally {
      this.deleting = false;
    }
  }

  tutup() {
    this.dialogHapus = false;
    this.$emit("input", false);
  }
}
